var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list__container"},[_c('List',{attrs:{"download-urls":_vm.downloadUrls,"baidu-api-token":_vm.baiduApiToken,"so360-download-config":_vm.so360DownloadConfig,"by-download-config":_vm.byDownloadConfig,"collect-enabled":_vm.collectEnabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }